import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { select } from '@/store'
import downloadImages from '@/utils/download-images'
import {
  ShareByCraigslist,
  ShareByKijiji,
  ShareByFacebook,
  ShareByPhone,
  ShareByEmail,
  ShareListingMain
} from './index'

const ShareListingDialogs = ({ listingId, visible, showModal, closeModal }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch.listing.load(listingId)
  }, [dispatch.listing, listingId])

  const data = useSelector(state =>
    select.listing.editListing(state, {
      listingId
    })
  )

  const handleDownloadImages = () => {
    downloadImages(data)
  }

  return (
    <>
      <ShareListingMain
        listingId={listingId}
        open={visible.mainDialog}
        onClose={closeModal('mainDialog')}
        showModal={showModal}
      />
      <ShareByPhone
        listingId={listingId}
        open={visible.phoneDialog}
        onClose={closeModal('phoneDialog')}
        showMainModal={showModal('mainDialog')}
      />
      <ShareByEmail
        listingId={listingId}
        open={visible.emailDialog}
        onClose={closeModal('emailDialog')}
        showMainModal={showModal('mainDialog')}
      />
      <ShareByCraigslist
        open={visible.craigslistDialog}
        onClose={closeModal('craigslistDialog')}
        handleDownloadImages={handleDownloadImages}
        showMainModal={showModal('mainDialog')}
      />
      <ShareByKijiji
        open={visible.kijijiDialog}
        onClose={closeModal('kijijiDialog')}
        handleDownloadImages={handleDownloadImages}
        showMainModal={showModal('mainDialog')}
      />
      <ShareByFacebook
        open={visible.facebookDialog}
        onClose={closeModal('facebookDialog')}
        handleDownloadImages={handleDownloadImages}
        showMainModal={showModal('mainDialog')}
      />
    </>
  )
}

export default ShareListingDialogs
